/**
 * Проставляем фокус на заданном элементе
 * @param {HTMLInputElement} element
 */
var activate = setTimeout.bind(window, function(element) {
    var elementId = element.getAttribute("data-id");
    if (elementId) {
        element = document.getElementById(elementId);
    }

    if (!element) {
        return;
    }

    if (element.disabled) {
        return;
    }

    element.focus();
    element.scrollIntoView({
        block: 'center'
    });

    // set cursor to end of text input
    var valueLength = element.value && element.value.length;
    if (valueLength && ["text", "search", "url", "tel", "password"].indexOf(element.type) >= 0) {
        element.setSelectionRange(valueLength, valueLength);
    }
}, 0);

export default { activate };

export { activate };
